  import React, { Suspense } from "react";
  import { connect }     from "react-redux";

  import cx from "classnames";
  import PropTypes from "prop-types";
  import { Switch, Route } from "react-router-dom";
  // creates a beautiful scrollbar
  import PerfectScrollbar from "perfect-scrollbar";
  import "perfect-scrollbar/css/perfect-scrollbar.css";

  // @material-ui/core components
  import withStyles from "@material-ui/core/styles/withStyles";

  // core components
  import AdminNavbar     from "components/Navbars/AdminNavbar/AdminNavbar.jsx";
//import Sidebar         from "components/Sidebar/Sidebar.jsx";
  import routes          from "routes.js";
  import appStyle        from "layouts/adminStyle.jsx";
//import { Translation } from "react-i18next";

  //------------------
  // Custom components
  //------------------
  //https://github.com/yeutech-lab/react-cookiebot/blob/master/src/CookieBot.js
  import CookieBot                                           from "components/CookieBotWB/CookieBotWB.jsx"; //[CookieBot]---andrew/nikos
//import CookieBot                                           from 'react-cookiebot';                        //[CookieBot]---npm

  import Loader          from "../components/Loader/Loader";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../_helpers";
  import { wu_Utilities }                                    from "../_services";
  import { wu_LoginLogoutService }                           from "../_services";
  import { api }                                             from "../_constants";
  //----------
  // Libraries
  //----------
  import Cookies                                             from 'js-cookie';

// Call some material Theme layout components to customize basic theme functions
//import { createMuiTheme } from "@material-ui/core/styles";
// Customize 'createMuiTheme' functions
// const theme = createMuiTheme({
//   typography: {
//     useNextVariants: true
//   },
//   palette: {
//     background: {
//       default: "#e8eeef"
//     }
//   }
// });
  var ps;

  const filename = "Admin ";


class Dashboard extends React.Component {
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName);}

    super(props);
    this.state = {
      open              : false,
      docked            : false,
      mobile            : true,

      mobileOpen        : false,
      image             : null,
      color             : "white",
      bgColor           : "TS_Main",
      adminBgColor      : "TS_Main",
      hasImage          : true,
      fixedClasses      : "dropdown",
      localStorageParam : true,

      cookieReloads     : 0,
    };
  //if (localStorage.getItem("user") === null) {
    if (localStorage.getItem("isLoggedIn") !== "true") {
      this.state.localStorageParam = false;
    }
    this.resizeFunction                       = this.resizeFunction.bind(this);
    this.rerenderParentCallback               = this.rerenderParentCallback.bind(this);
    this.rerenderParentCallbackLogout         = this.rerenderParentCallbackLogout.bind(this);
    this.rerenderParentCallbackLogoutAndSite  = this.rerenderParentCallbackLogoutAndSite.bind(this);

    //[CookieBot]
    this.updateCookiebotSettings   = this.updateCookiebotSettings.bind(this);
    this.updateCookiebotUIElements = this.updateCookiebotUIElements.bind(this);
    this.bindCookiebotListener     = this.bindCookiebotListener.bind(this);
    this.revertCookieBotUIChanges  = this.revertCookieBotUIChanges.bind(this);

    //let api_webapp_path = localStorage.getItem("api_webapp_path");
    localStorage.setItem("api_webapp_path", api.webapp_path);

    let wpwpmlcurrentlanguage = Cookies.get('wp-wpml_current_language');
    if(wpwpmlcurrentlanguage===null || wpwpmlcurrentlanguage===''){wpwpmlcurrentlanguage = 'el';}
    localStorage.setItem("lang",wpwpmlcurrentlanguage);
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}

    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.mainPanel, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", this.resizeFunction);

    //[CookieBot]
    var loaded      = window.CookieBot ? window.CookieBot.loaded    : "";
    var consented   = window.CookieBot ? window.CookieBot.consented : "";
    var necessary   = window.CookieBot && window.CookieBot.consent ? window.CookieBot.consent.necessary   : "";
    var preferences = window.CookieBot && window.CookieBot.consent ? window.CookieBot.consent.preferences : "";
    var statistics  = window.CookieBot && window.CookieBot.consent ? window.CookieBot.consent.statistics  : "";
    var marketing   = window.CookieBot && window.CookieBot.consent ? window.CookieBot.consent.marketing   : "";
    if(api.print_logs){console.log(methName+"CookieBot loaded      = "+loaded);}
    if(api.print_logs){console.log(methName+"CookieBot consented   = "+consented);}
    if(api.print_logs){console.log(methName+"CookieBot necessary   = "+necessary);}
    if(api.print_logs){console.log(methName+"CookieBot preferences = "+preferences);}
    if(api.print_logs){console.log(methName+"CookieBot statistics  = "+statistics);}
    if(api.print_logs){console.log(methName+"CookieBot marketing   = "+marketing);}
    this.initCookieBotChanges();
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    const mediaQuery = window.matchMedia('(min-width: 900px)'); //768px->900
    if (mediaQuery.matches) { console.log("setLarge");this.setLarge(); }
    else                    { console.log("setSmall");this.setSmall(); }
    mediaQuery.addListener((mq) => {
      if (mq.matches) { console.log("setLarge");this.setLarge(); }
      else            { console.log("setSmall");this.setSmall(); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}

    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
    window.removeEventListener("resize", this.resizeFunction);
  }
  //----------------------------------------------------------------------------------------------------
  componentDidUpdate(e) {
    let methName = filename+"componentDidUpdate ";
    if(api.print_logs){console.log(methName);}

    if (e.history.location.pathname !== e.location.pathname) {
      if(api.print_logs){console.log(methName+"pathname changed");}
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
        localStorage.setItem("mobileOpen", "false");
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[CookieBot]---------------------------------------
  //----------------------------------------------------------------------------------------------------
  //lala=(e)=>console.log(e);
  initCookieBotChanges() {
      //var time = performance.now();
      let i=0;
      var handle = setInterval(() => {
        i++;
        let cookieBotUILoaded = document.getElementById('CybotCookiebotDialogBodyLevelButtonAccept')!==null;
        console.log(this.getCompactDateTime()+" window.CookieBot.loaded="+window.CookieBot.loaded+",window.CookieBot.consented="+window.CookieBot.consented+",cookieBotUILoaded="+cookieBotUILoaded+",i="+i);
        if(window.CookieBot.loaded){
          localStorage.setItem("window_CookieBot_loaded", "true");
        }
        if(window.CookieBot.loaded && window.CookieBot.consented){
          if(api.print_logs){console.log("window.CookieBot.loaded="+window.CookieBot.loaded+",window.CookieBot.consented="+window.CookieBot.consented+",cookieBotUILoaded="+cookieBotUILoaded+",i="+i+" ===> User has already Consented => clearInterval");}
          clearInterval(handle);
          handle = null;
        }
        if(document.getElementById('CybotCookiebotDialogBodyLevelButtonAccept')){
          if(api.print_logs){console.log("window.CookieBot.loaded="+window.CookieBot.loaded+",window.CookieBot.consented="+window.CookieBot.consented+",cookieBotUILoaded="+cookieBotUILoaded+",i="+i+" ===> Waiting user consent => clearInterval & updateCookiebotSettings");}
          clearInterval(handle);
          handle = null;
          setTimeout(() => this.updateCookiebotSettings(), 600);
        }
        if(i>200 && handle!==null){
          if(api.print_logs){console.log("window.CookieBot.loaded="+window.CookieBot.loaded+",window.CookieBot.consented="+window.CookieBot.consented+",cookieBotUILoaded="+cookieBotUILoaded+",i="+i+" ===> Too many tries, clearInterval & do nothing");}
          clearInterval(handle);
          handle = null;
        }
      }, 50)
  }
  //----------------------------------------------------------------------------------------------------
  updateCookiebotSettings() {
    let methName = filename+"updateCookiebotSettings ";
    if(api.print_logs){console.log(methName);}

    try{document.getElementById('CybotCookiebotDialogBodyLevelButtonAccept').style.visibility = 'hidden'; }catch(err){console.log(methName+"err01="+err)}
    try{document.getElementById('CybotCookiebotDialogBodyLevelButtons').style.visibility      = 'hidden'; }catch(err){console.log(methName+"err02="+err)}
    this.updateCookiebotUIElements();
    this.bindCookiebotListener();
    //if(this.state.cookieReloads){setTimeout(function() {window.location.reload();}.bind(this), 500);}
  }
  //----------------------------------------------------------------------------------------------------
  updateCookiebotUIElements() {
    let methName = filename+"updateCookiebotUIElements ";
    if(api.print_logs){console.log(methName);}

  //let acceptAll = localStorage.getItem("lang")==="el" ? 'Αποδοχή όλων' : 'Accept All';
    let acceptAll = localStorage.getItem("lang")==="el" ? 'Αποδοχή' : 'Accept';
    try{document.getElementById('CybotCookiebotDialogBodyLevelButtonAccept').textContent             = acceptAll;           }catch(err){console.log(methName+"err01="+err)}
    try{document.getElementById('CybotCookiebotDialogBodyLevelButtonsSelectPane').style.visibility   = 'hidden';            }catch(err){console.log(methName+"err02="+err)}
    try{document.getElementById('CybotCookiebotDialogBodyLevelDetailsWrapper').style.borderLeftWidth = '1px';               }catch(err){console.log(methName+"err03="+err)}
    try{document.getElementById('CybotCookiebotDialogBodyLevelDetailsWrapper').style.borderLeftColor = 'rgb(204, 204, 204)';}catch(err){console.log(methName+"err04="+err)}
    try{document.getElementById('CybotCookiebotDialogBodyLevelDetailsWrapper').style.borderLeftStyle = 'solid';             }catch(err){console.log(methName+"err05="+err)}
    try{document.getElementById('CybotCookiebotDialogBodyLevelButtonAccept').style.visibility        = 'visible';           }catch(err){console.log(methName+"err06="+err)}
    try{document.getElementById('CybotCookiebotDialogBodyLevelButtons').style.visibility             = 'visible';           }catch(err){console.log(methName+"err07="+err)}
    try{document.getElementById("CybotCookiebotDialogBodyLevelButtonPreferences").checked            = true;                }catch(err){console.log(methName+"err08="+err)}
    try{document.getElementById("CybotCookiebotDialogBodyLevelButtonStatistics").checked             = true;                }catch(err){console.log(methName+"err09="+err)}
    try{document.getElementById("CybotCookiebotDialogBodyLevelButtonMarketing").checked              = true;                }catch(err){console.log(methName+"err10="+err)}
    // document.getElementById("CybotCookiebotDialogBodyLevelButtonLevelOptinDeclineAll").style.display = "none";
    // document.getElementById("CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection").style.display = "none";
    // document.getElementById("CybotCookiebotDialog").style.top = (parseInt(document.getElementById("CybotCookiebotDialog").style.top) + 50) + 'px';

    // document.getElementById("CybotCookiebotDialogBodyLevelButtonLevelOptinDeclineAll").style.visibility = "hidden";
    // document.getElementById("CybotCookiebotDialogBodyLevelButtonLevelOptinDeclineAll").style.height = "0px";
    // document.getElementById("CybotCookiebotDialogBodyLevelButtonLevelOptinDeclineAll").style.padding = "0px";
    // document.getElementById("CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection").style.visibility = "hidden";
    // document.getElementById("CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection").style.height = "0px";
    // document.getElementById("CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection").style.padding = "0px";
  }
  //----------------------------------------------------------------------------------------------------
  bindCookiebotListener() {
    let methName = filename+"bindCookiebotListener ";
    if(api.print_logs){console.log(methName);}

    try{document.getElementById('CybotCookiebotDialogBodyLevelDetailsButton').addEventListener('click', () => this.revertCookieBotUIChanges());}catch(err){console.log(methName+"err01="+err)}
  }
  //----------------------------------------------------------------------------------------------------
  revertCookieBotUIChanges(){
    let methName = filename+"revertCookieBotUIChanges ";
    if(api.print_logs){console.log(methName);}

  //try{document.getElementById('CybotCookiebotDialogBodyLevelButtonAccept').textContent            = 'OK';      }catch(err){console.log(methName+"err01="+err)}
    try{document.getElementById('CybotCookiebotDialogBodyLevelButtonPreferences').checked            = false;    }catch(err){console.log(methName+"err01="+err)}
    try{document.getElementById('CybotCookiebotDialogBodyLevelButtonStatistics').checked             = false;    }catch(err){console.log(methName+"err03="+err)}
    try{document.getElementById('CybotCookiebotDialogBodyLevelButtonMarketing').checked              = false;    }catch(err){console.log(methName+"err04="+err)}
    try{document.getElementById('CybotCookiebotDialogBodyLevelButtonsSelectPane').style.visibility   = 'visible';}catch(err){console.log(methName+"err05="+err)}
    try{document.getElementById('CybotCookiebotDialogBodyLevelDetailsWrapper').style.borderLeftStyle = 'none';   }catch(err){console.log(methName+"err06="+err)}

    //try{document.getElementById('CybotCookiebotDialogBodyLevelButtonAccept').addEventListener('click',  () => this.acceptCookieBot());}catch(err){console.log(methName+"err01="+err)}
  }
  //----------------------------------------------------------------------------------------------------
  //acceptCookieBot(){
  //  let methName = filename+"acceptCookieBot ";
  //  if(api.print_logs){console.log(methName);}
  //}
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  setSmall = () => {
      this.setState({mobileOpen:true, open: false, docked: false, mobile: true})
      localStorage.setItem("mobileOpen", "true");
  }
  setLarge = () => {
      this.setState({mobileOpen:false, open: true, docked: true, mobile: false})
      localStorage.setItem("mobileOpen", "false");
  }
  //----------------------------------------------------------------------------------------------------
  resizeFunction() {
    let methName = filename+"resizeFunction ";
    if(api.print_logs){console.log(methName);}

    if (window.innerWidth >= 960) {
      //console.log(methName+"window.innerWidth >= 960");
      this.setState({ mobileOpen: false });
      localStorage.setItem("mobileOpen", "false");
    }
    else{
      //console.log(methName+"window.innerWidth < 960");
      localStorage.setItem("mobileOpen", "true");
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleDrawerToggle = () => {
    if(api.print_logs){console.log('handleDrawerToggle');}
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  //----------------------------------------------------------------------------------------------------
  rerenderParentCallback(lang) {
    let methName = filename+"rerenderParentCallback ";
    if(api.print_logs){console.log(methName);}
    let wpwpmlcurrentlanguage = 'en';
    if(lang==='gr' || lang==='el'){wpwpmlcurrentlanguage = 'el';}
    Cookies.set('wp-wpml_current_language', wpwpmlcurrentlanguage);
    localStorage.setItem("lang",lang);
    this.forceUpdate();

    // //[CookieBot]
    // try{
    //   var loaded      = window.CookieBot ? window.CookieBot.loaded    : "";
    //   var consented   = window.CookieBot ? window.CookieBot.consented : "";
    //   var necessary   = window.CookieBot && window.CookieBot.consent ? window.CookieBot.consent.necessary   : "";
    //   var preferences = window.CookieBot && window.CookieBot.consent ? window.CookieBot.consent.preferences : "";
    //   var statistics  = window.CookieBot && window.CookieBot.consent ? window.CookieBot.consent.statistics  : "";
    //   var marketing   = window.CookieBot && window.CookieBot.consent ? window.CookieBot.consent.marketing   : "";
    //   if(api.print_logs){console.log(methName+"CookieBot loaded      = "+loaded);}
    //   if(api.print_logs){console.log(methName+"CookieBot consented   = "+consented);}
    //   if(api.print_logs){console.log(methName+"CookieBot necessary   = "+necessary);}
    //   if(api.print_logs){console.log(methName+"CookieBot preferences = "+preferences);}
    //   if(api.print_logs){console.log(methName+"CookieBot statistics  = "+statistics);}
    //   if(api.print_logs){console.log(methName+"CookieBot marketing   = "+marketing);}
    //   if (!window.CookieBot.consented) {
    //     document.getElementById('CookieBot').setAttribute('data-culture', lang);
    //     window.CookieBot.renew();
    //     this.initCookieBotChanges();
    //   }
    // }catch(err){
    //   console.log(methName+"err="+JSON.stringify(err));
    // }
  }
  //----------------------------------------------------------------------------------------------------
  rerenderParentCallbackLogout(tmp) {
    let methName = filename+"rerenderParentCallbackLogout ";
    if(api.print_logs){console.log(methName);}

    setTimeout(function() { //Start the timer
      //---------
      //wu_logout
      //---------
      wu_LoginLogoutService
      .wu_logout()
      .then(res => {
        console.log("!!!!!!!!!!localStorage.setItem(isLoggedIn=false)-1!!!!!!!!!!");
        localStorage.setItem("isLoggedIn","false");
        Cookies.set('isLoggedInAtWebApp', 'false', { expires:1, path:'' });
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        this.forceUpdate();
      })
      .catch(err => {
        //this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){
          //this.dialog_handleOpen(err.returnText);
        }
        //Force logout from Local Session if WS does not answer
        console.log("!!!!!!!!!!localStorage.setItem(isLoggedIn=false)-2!!!!!!!!!!");
        localStorage.setItem("isLoggedIn","false");
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        this.forceUpdate();
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  rerenderParentCallbackLogoutAndSite(tmp) {
    let methName = filename+"rerenderParentCallbackLogoutAndSite ";
    if(api.print_logs){console.log(methName);}

    if(localStorage.getItem("isLoggedIn")==="false"){
      console.log("!!!!!!!!!!localStorage.setItem(isLoggedIn=false)-0!!!!!!!!!!");
      localStorage.setItem("isLoggedIn","false");
      Cookies.set('isLoggedInAtWebApp', 'false', { expires:1, path:'' });
           if(tmp==="HELP")    { window.location.href = this.getHelpURL(); }
      else if(tmp==="SERVICES"){ window.location.href = this.getServicesURL(); }
      else                     { window.location.href = this.getHomePageURL(); }
      return;
    }

    setTimeout(function() { //Start the timer
      //---------
      //wu_logout
      //---------
      wu_LoginLogoutService
      .wu_logout()
      .then(res => {
        console.log("!!!!!!!!!!localStorage.setItem(isLoggedIn=false)-1!!!!!!!!!!");
        localStorage.setItem("isLoggedIn","false");
        Cookies.set('isLoggedInAtWebApp', 'false', { expires:1, path:'' });
             if(tmp==="HELP")    { window.location.href = this.getHelpURL(); }
        else if(tmp==="SERVICES"){ window.location.href = this.getServicesURL(); }
        else                     { window.location.href = this.getHomePageURL(); }
      })
      .catch(err => {
        //this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){
          //this.dialog_handleOpen(err.returnText);
        }
        //Force logout from Local Session if WS does not answer
        console.log("!!!!!!!!!!localStorage.setItem(isLoggedIn=false)-2!!!!!!!!!!");
        localStorage.setItem("isLoggedIn","false");
        Cookies.set('isLoggedInAtWebApp', 'false', { expires:1, path:'' });
             if(tmp==="HELP")    { window.location.href = this.getHelpURL(); }
        else if(tmp==="SERVICES"){ window.location.href = this.getServicesURL(); }
        else                     { window.location.href = this.getHomePageURL(); }
      });
    }.bind(this), 100);
  }
  //----------------------------------------------------------------------------------------------------
  getHelpURL(){
    if(localStorage.getItem("lang")==="en"){ return api.url_website+"/en/customer-service-themes/";}
    else                                   { return api.url_website+"/customer-service-gr/";}
  }
  getServicesURL(){
    if(localStorage.getItem("lang")==="en"){ return api.url_website+"/en/sending-receiving-cash/";}
  //else                                   { return api.url_website+"/western-union-worldwide-network/";}
    else                                   { return api.url_website+"/oi-ypiresies-mas/";}
  }
  getHomePageURL(){
    if(localStorage.getItem("lang")==="en"){ return api.url_website+"/en/";}
    else                                   { return api.url_website+"/";}
  }
  //----------------------------------------------------------------------------------------------------
  getCompactDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');

      return `${year}${month}${day}${hours}${minutes}${seconds}`; // Example: 20250125123045
  }
  //----------------------------------------------------------------------------------------------------
  getRoute() {
    let methName = filename+"getRoute ";
    if(api.print_logs){console.log(methName);}

    return this.props.location.pathname !== "/full-screen-maps";
  }
  //----------------------------------------------------------------------------------------------------
  getActiveRoute = routes => {
    let methName = filename+"getActiveRoute ";
    if(api.print_logs){console.log(methName);}

    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  //----------------------------------------------------------------------------------------------------
  getRoutes = routes => {
    let methName = filename+"getRoutes ";
    if(api.print_logs){console.log(methName);}

    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      //console.log('prop.path='+prop.path);
      return (
        <Route
          exact
          path={api.webapp_path + prop.path}
          component={prop.component}
          key={key}
        />
        // <Route
        //   exact
        //   key={key}
        //   path={api.webapp_path + prop.path}
        //   render={prop.component}
        // />
      );
    });
  };
  //----------------------------------------------------------------------------------------------------
  getActiveRoute = routes => {
    let methName = filename+"getActiveRoute ";
    if(api.print_logs){console.log(methName);}

    //let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (window.location.href.indexOf(api.webapp_path + routes[i].path) !== -1) {
        return (
          <span>(routes[i].name)</span>
          //<Translation>{(t, { i18n }) => <span>{t(routes[i].name)}</span>}</Translation>
        );
      }
    }
    //return activeRoute;
  };
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const { classes, ...rest } = this.props;
    const mainPanel =
      classes.mainPanel +
      " " +
      cx({
        [classes.mainPanelWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1
      });
    return (
      <div className={classes.wrapper}>
          {/*
          {this.state.mobile===false ? ( "" ) : (
            <Suspense fallback={<Loader />}>
            <Sidebar
              routes={routes}
              logoText1={<Translation>{(t, { i18n }) => <span>{t("mainTitle")}</span>}</Translation>}
              logoText2={<Translation>{(t, { i18n }) => <span>{t("MainSubtitle")}</span>}</Translation>}
              logo={logo}
              image={this.state.image}
              handleDrawerToggle={this.handleDrawerToggle}
              open={this.state.mobileOpen}
              color={this.state.color}
              bgColor={this.state.bgColor}
              layout={api.webapp_path}
              {...rest}
            />
          </Suspense>
        )}
        */}
        <div className={mainPanel} ref="mainPanel">
          <Suspense fallback={<Loader />}>
            <AdminNavbar
              rerenderParentCallback={this.rerenderParentCallback}
              rerenderParentCallbackLogout={this.rerenderParentCallbackLogout}
              rerenderParentCallbackLogoutAndSite={this.rerenderParentCallbackLogoutAndSite}
              handleDrawerToggle={this.handleDrawerToggle}
              brandText={this.getActiveRoute(routes)}
              color={this.state.adminBgColor}
              mobile={this.state.mobile}
              {...rest}
            />
          </Suspense>

          {this.getRoute() ? (
            <div className={classes.content}>
              <div className={classes.container}>
                <Switch>{this.getRoutes(routes)}</Switch>
              </div>
            </div>
          ) : (
            <div className={classes.map}>
              <Switch>{this.getRoutes(routes)}EMPTY</Switch>
            </div>
          )}
        </div>
        {/* CookieBot */}
        <CookieBot domainGroupId={api.CookieBotdomainGroupId}  />
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { loggedIn } = state.authentication;
  return {
    loggedIn
  };
}

export default connect(mapStateToProps)(
  withStyles(appStyle)(Dashboard)
);
